<template>
  <b-container
    fluid
    class="p-0"
    :class="{ bk_f3: currentStage == componentNames.length - 1 }"
  >
    <b-row class="m-0">
      <b-col class="p-0">
        <FormSteps
          :currentStage="currentStage"
          :steps="formSteps"
          :title="formTitle"
          type="quote"
          @back="goToStage(currentStage - 1)"
        ></FormSteps>
      </b-col>
    </b-row>

    <b-container class="affiliate-form-container">
      <div
        class="appt-content d-flex flex-row justify-content-center"
        :class="{ bk_f3: currentStage == componentNames.length - 1 }"
      >
        <div
          class="select-area scroll-area"
          :class="{ appt_confirm: currentStage == componentNames.length - 1 }"
          v-if="!affiliateComplete"
        >
          <div class="appt-sub-comp">
            <div
              class="validation-warning"
              v-if="
                hasErrors.responseCode !== null && hasErrors.responseCode !== 1
              "
            >
              <b-alert show dismissible variant="warning">
                {{ displayErrors }}
              </b-alert>
            </div>

            <div v-for="(component, a) in componentNames" :key="a">
              <component
                :canSubmitLead="canSubmitLead"
                :showAutomotive="true"
                :onConfirm="onConfirm"
                :confirmTitle="confirmTitle"
                :is="component.name"
                :confirmComponents="confirmComponents"
                v-if="a == currentStage"
                @gotoEdit="goToStage($event, int)"
                @next="goToStage(a + 1)"
                @back="goToStage(a - 1)"
              >
                <template v-slot:header>
                  <div class="appt-cap1 t-bold mt-2 mb-2">1. Select Store</div>
                </template>
                <template v-slot:footer>
                  <div class="goto-next">
                    <div
                      class="btn-next add-next ml-auto new-locator-next"
                      :class="{ 'active c-pointer': storeSelected }"
                      @click="
                        if (storeSelected) {
                          goToStage(a + 1);
                        }
                      "
                    >
                      Next
                    </div>
                  </div>
                </template></component
              >
            </div>
          </div>
        </div>
        <!-- @TODO - Setup a Quote Specific Success Component to Load Here -->
        <FormSuccess v-if="affiliateComplete"> </FormSuccess>
        <!-- Start of Desktop Right Hand Review Area -->
        <div
          class="appt-details pd-30 scroll-area"
          v-if="currentStage !== componentNames.length - 1"
        >
          <div class="appt-cap1">Quote Details</div>
          <div class="appt-confirm-stages">
            <component
              v-for="(component, index) in reviewNames"
              :is="component"
              :key="index"
              :number="index + 1"
              @goToEdit="goToStage(index)"
            />
            <div class="confirm-stage">
              <div class="d-title">
                <span class="lbl-cap8 text-bold">4. Confirm Quote</span>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Desktop Right Hand Review Area -->
      </div>
    </b-container>
  </b-container>
</template>

<script>
import FormServiceReview from "./../partials/FormServiceReview";
import ApptService from "./../partials/FormServices";
import FormSteps from "./../partials/FormSteps";
import FormStoreReview from "./../partials/FormStoreReview";
import AffiliateStoreSelect from "@/components/store-locator/StoreLocator.vue";
import FormContactReview from "./../partials/FormContactReview";
import AffiliateCoupons from "../affiliate/AffiliateCoupons.vue";
import ApptContact from "./../partials/FormContact";
import FormCouponReview from "../partials/FormCouponReview.vue";
import AffiliateConfirm from "../affiliate/AffiliateConfirm.vue";
import FormSuccess from "./../quote/FormSuccess";
import ApptConfirm from "../appointment/ApptConfirm.vue";
import FormReview from "../partials/FormReview.vue";
import DynamicConfirm from "./DynamicConfirm.vue";

export default {
  components: {
    ApptContact,
    FormSteps,
    ApptService,
    FormStoreReview,
    FormContactReview,
    AffiliateConfirm,
    AffiliateStoreSelect,
    AffiliateCoupons,
    FormCouponReview,
    FormServiceReview,
    FormSuccess,
    DynamicConfirm,
    ApptConfirm,
    FormReview,
  },

  data: () => {
    return {
      displayErrors: "",
    };
  },
  props: {
    canSubmitLead: Function,
    onConfirm: Function,
    confirmTitle: String,
    useServices: Boolean,
    componentNames: Array,
    reviewNames: Array,
    formTitle: String,
    formSteps: Array,
    confirmComponents: Array,
  },
  created() {
    if (this.affiliateComplete) {
      this.$store.commit("resetUserForm", { type: "quote" });
    }
  },
  mounted() {
    this.$store.commit("setUser", { page_url: window.location.href });
    this.$store.dispatch("getCoupons");
    //@TODO - If User Has a Store, then we just auto-set them to step 2?
    this.$gtm.trackEvent({
      event: "begin_checkout_quote",
      category: "Lead",
      action: "Started Quote",
      noninteraction: false,
    });
  },
  computed: {
    hasErrors() {
      return this.$store.state.form_response;
    },
    storeSelected() {
      if (this.$store.getters.formStore) {
        return this.$store.getters.formStore;
      }
      return false;
    },
    formComplete() {
      return this.$store.getters.quoteFormComplete;
    },
    affiliateComplete() {
      return this.$store.state.affiliate.complete;
    },
    currentStage() {
      return this.$store.getters.currentStage;
    },
  },
  destroyed() {
    if (this.affiliateComplete) {
      this.$store.commit("resetUserForm", { type: "quote" });
    }
  },
  methods: {
    storePhone() {
      return this.$store.getters.getUserStorePhone;
    },

    goToStage(stageNumber) {
      this.$store.commit("setStageNumber", stageNumber);
    },
  },
};
</script>
<style>
.form-complete {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-block: 5%;
  flex-direction: column;
  text-align: center;
  padding-inline: 10%;
}
#tint-world-modal .affiliate-form-container .select-area {
  max-width: 100%;
  min-width: 275px;
  padding: 1rem;
}
.store-container > .map-area {
  min-width: 100%;
}
#tint-world-modal .appt-details {
  min-width: 300px;
  max-width: 100%;
  height: auto;
}
.affiliate-form-container {
  overflow: hidden;
}
.store-container {
  flex-wrap: wrap;
}
.store-container .vue-map-container {
  height: 250px !important;
}
.store-container .single-result-container {
  max-width: 100%;
  overflow: hidden;
}
.store-container .location-area .geolocate-area .b-loc {
  width: 90%;
  text-align: center;
  margin-left: auto;
}
#tint-world-modal .goto-next {
  padding-inline: 0px;
}
.appt-store {
  padding-inline: 0px;
  margin: 1rem;
}
.appt-contact {
  margin: 1rem;
}
.appt-contact .lbl-information {
  text-align: left;
}
.person-info-area {
  align-items: start;
}
#single-store-map {
  display: none;
}
.store-container .btn-actions .store-details-btn {
  display: none;
}
.store-container .location-area .place-area .place-row {
  margin: 0;
  padding-right: 0px;
}
.single-result-container .select-store-btn {
  max-height: 200px;
}
@media (max-width: 767px) {
  .single-result-container .select-store-btn {
    max-height: 200px;
  }
  #tint-world-modal .goto-next {
    position: relative;
    width: 100%;
    margin-top: 100px;
  }
  #tint-world-modal .goto-next .btn-next {
    width: 100%;
    position: absolute;
  }
  .store-container .location-area .scroll-area {
    max-height: 500px;
  }
}
.browse-site-success {
  display: none;
}
.store-container .location-area .heart-area {
  display: none;
}
</style>
